import { render, staticRenderFns } from "./FolhaPagamentoPorCpf.vue?vue&type=template&id=b9a17b54"
import script from "./FolhaPagamentoPorCpf.vue?vue&type=script&lang=js"
export * from "./FolhaPagamentoPorCpf.vue?vue&type=script&lang=js"
import style0 from "./FolhaPagamentoPorCpf.vue?vue&type=style&index=0&id=b9a17b54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports